import React, { useState, useEffect, useRef, useImperativeHandle } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions/ticket-action';
import PropTypes from 'prop-types';
import * as service from '../../services/sTicket/ticket.service';



const ReadForm = ({ preSetData, handleAnswerFormOpen, handleSelectedTicket}) => {
  const [formData, setFormData] = useState({
    id: '',
    subject: '',
    category: '',
    assignee: '',
    priority: '',
    status: '',
    creation_date: ''    
  });

  useEffect(() => {
    const {
      id, subject, category, assignee, priority, status, creation_date
    } = preSetData;
    setFormData({
      ...formData,
      id,
      subject,
      category,
      assignee,
      priority,
      status,
      creation_date
    });
  }, [preSetData]);

  const {
    id,
    subject,
    category,
    assignee,
    priority,
    status,
    creation_date
  } = formData;

  const onOpenAnswerAddPanel = (tableItem) => {        
    handleAnswerFormOpen(tableItem.id);
};
    
  return (    
    <div>
        <div>
            <div key={id} >                
                <div className="row col-md-12">
                    <label className="col-md-4 control-label">ticket number</label>
                    <label className="col-md-2 control-label">{id}</label>
                    <div className="col-md-6 text-end">
                    <button
                            type="button"
                            className="btn btn-outline-primary btn-sm delete-btn"
                            onClick={() => onOpenAnswerAddPanel(formData)}
                            >       Add Answer
                        </button>

                        <button
                            type="button"
                            className="btn btn-outline-primary btn-sm"
                            onClick={() => handleSelectedTicket(id)}
                            >       Dcouments
                        </button>
                    </div>
                    
                </div>
                <div className="col-md-12">
                    <label className="col-md-4 control-label">creation date</label>
                    <label className="col-md-8 control-label">{creation_date}</label>
                </div>
                <div className="col-md-12">
                    <label className="col-md-4 control-label">category</label>
                    <label className="col-md-8 control-label">{category}</label>
                </div>
                <div className="col-md-12">
                    <label className="col-md-4 control-label">assignee</label>
                    <label className="col-md-8 control-label">{assignee}</label>
                </div>
                <div className="col-md-12">                    
                    <label className="col-md-4 control-label">priority</label>
                    <label className="col-md-8 control-label">{priority}</label>
                </div>
                <div className="col-md-12">
                    <label className="col-md-4 control-label">status</label>
                    <label className="col-md-8 control-label">{status}</label>
                </div>
                <div className="col-md-12">
                    <label className="col-md-4 control-label">subject</label>
                    <label className="col-md-8 control-label">{subject}</label>
                </div>
            </div>
        </div>
      
    </div>
  );
};



export default ReadForm;
